import styles from "./FaqDetail.module.css";
import commonStyles from "./../../Common.module.css";
import React, { useState, useEffect } from "react";
import axios from 'axios';
import { Link, useParams } from "react-router-dom";

export default function DetailDetail() {

  const { id } = useParams();
  const [faq, setFaq] = useState({
    faq_title: '',
    faq_writer: '',
    faq_regdate: '',
    faq_count: '',
    faq_content: ''
  });

  useEffect(() => {
    axios.
    get('https://port-0-petmilyreal-1272llwrbm1kq.sel5.cloudtype.app/api/faqDetail/' + id).
    then((response) => {
      setFaq(response.data);
    }).
    catch(() => {
      alert("선택한 데이터가 없습니다.");
    });
  }, []);

  const contents = faq.faq_content.split('\n').map((it) => <p>{it}</p>);

  return (
    <div className={styles["DetailDetail"]}>
            <div className={commonStyles["cateTitle"]}>
                <h1>자주묻는질문</h1>
            </div>

            <div className={styles["boardPackage"]}>
                <table>
                    <tr>
                        <th scope="row">제목</th>
                        <td>[{faq.question_type}] {faq.faq_title}</td>
                    </tr>
                    <tr>
                        <th scope="row">작성자</th>
                        <td><span>{faq.faq_writer}</span></td>
                    </tr>
                    <tr>
                        <th scope="row">작성일</th>
                        <td><span>{faq.faq_regdate}</span></td>
                        <th scope="row">조회수</th>
                        <td><span>{faq.faq_count}</span></td>
                    </tr>
                    <tr>
                        <td className={styles["contents"]}>
                            {contents}
                        </td>
                    </tr>
                </table>
                <div id="bottomBoard">
                    <Link to="/community/Faq"><input type="button" value="목록" /></Link>
                </div>
            </div>
        </div>);

}